export default {
    getConfig: (state: any): any => state.setting,
    getDefault: (state: any): any => state.default,
};